import create from 'zustand';
import { devtools } from 'zustand/middleware';

interface VehicleDetailCommentsModalState {
  isCommentModalVisible: boolean;
  setCommentModalVisible: (val: boolean) => void;
}

export const useVehicleDetailCommentsModal =
  create<VehicleDetailCommentsModalState>()(
    devtools((set) => {
      return {
        isCommentModalVisible: false,
        setCommentModalVisible: (val) =>
          set((state) => {
            return {
              ...state,
              isCommentModalVisible: val,
            };
          }),
      };
    })
  );
